import { render, staticRenderFns } from "./InitialPeriodDialog.vue?vue&type=template&id=88c88966&"
import script from "./InitialPeriodDialog.vue?vue&type=script&lang=js&"
export * from "./InitialPeriodDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports